// import { useState } from "react";
// import { Sprout, FlaskConical, Package, Calculator } from "lucide-react";

// import PageHeader from "../../components/AdminSideComponents/common/PageHeader";
// import PlantsTab from "./Calculator/PlantsTab";
// import GradeMixturesTab from "./Calculator/Grademixturestab";
// import ProductsTab from "./Calculator/Productstab";
// import CalculatorTab from "./Calculator/Calculatortab";
// // import GradeMixturesTab from "./Calculator/GradeMixturesTab";
// // import ProductsTab from "./Calculator/ProductsTab";
// // import CalculatorTab from "./Calculator/CalculatorTab";

// const TABS = [
//   { key: "plants", label: "Plants", Icon: Sprout },
//   { key: "mixtures", label: "Grade Mixtures", Icon: FlaskConical },
//   { key: "products", label: "Products", Icon: Package },
//   { key: "calculator", label: "Calculator", Icon: Calculator },
// ];

// const AdminCalculator = () => {
//   const [activeTab, setActiveTab] = useState("plants");

//   const renderTab = () => {
//     switch (activeTab) {
//       case "plants":
//         return <PlantsTab />;
//       case "mixtures":
//         return <GradeMixturesTab />;
//       case "products":
//         return <ProductsTab />;
//       case "calculator":
//         return <CalculatorTab />;
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="p-6">
//       <PageHeader title="Calculator" breadcrumb="Dashboard / Calculator" />

//       {/* Tab Bar */}
//       <div className="flex items-center gap-0 border-b border-borderLight mb-6 overflow-x-auto">
//         {TABS.map(({ key, label, Icon }) => {
//           const isActive = activeTab === key;
//           return (
//             <button
//               key={key}
//               onClick={() => setActiveTab(key)}
//               className={`flex items-center gap-2 px-5 py-3 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
//                 isActive
//                   ? "border-primaryAccent text-primaryAccent"
//                   : "border-transparent text-descriptionText hover:text-headingText hover:border-borderLight"
//               }`}
//             >
//               <Icon size={15} />
//               {label}
//             </button>
//           );
//         })}
//       </div>

//       {/* Tab Content */}
//       <div>{renderTab()}</div>
//     </div>
//   );
// };

// export default AdminCalculator;

import { useState } from "react";
import {
  Sprout,
  FlaskConical,
  Package,
  Calculator,
  LayoutList,
} from "lucide-react";

import PageHeader from "../../components/AdminSideComponents/common/PageHeader";
import PlantsTab from "./Calculator/PlantsTab";
import GradeMixturesTab from "./Calculator/Grademixturestab";
import ProductsTab from "./Calculator/Productstab";
import CalculatorTab from "./Calculator/Calculatortab";
import AllGradeCalculatorTab from "./Calculator/AlGradeCalculatorTab";
// import AllGradeCalculatorTab from "./Calculator/AllGradeCalculatorTab";

const TABS = [
  { key: "plants", label: "Plants", Icon: Sprout },
  { key: "mixtures", label: "Grade Mixtures", Icon: FlaskConical },
  { key: "products", label: "Products", Icon: Package },
  { key: "calculator", label: "Calculator", Icon: Calculator },
  { key: "all-grades", label: "All Grade Calculator", Icon: LayoutList },
];

const AdminCalculator = () => {
  const [activeTab, setActiveTab] = useState("plants");

  const renderTab = () => {
    switch (activeTab) {
      case "plants":
        return <PlantsTab />;
      case "mixtures":
        return <GradeMixturesTab />;
      case "products":
        return <ProductsTab />;
      case "calculator":
        return <CalculatorTab />;
      case "all-grades":
        return <AllGradeCalculatorTab />;
      default:
        return null;
    }
  };

  return (
    <div className="p-6">
      <PageHeader title="Calculator" breadcrumb="Dashboard / Calculator" />

      {/* Tab Bar */}
      <div className="flex items-center gap-0 border-b border-borderLight mb-6 overflow-x-auto">
        {TABS.map(({ key, label, Icon }) => {
          const isActive = activeTab === key;
          return (
            <button
              key={key}
              onClick={() => setActiveTab(key)}
              className={`flex items-center gap-2 px-5 py-3 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
                isActive
                  ? "border-primaryAccent text-primaryAccent"
                  : "border-transparent text-descriptionText hover:text-headingText hover:border-borderLight"
              }`}
            >
              <Icon size={15} />
              {label}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div>{renderTab()}</div>
    </div>
  );
};

export default AdminCalculator;
